"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var RootReducer_1 = require("../../../app/RootReducer");
var styles = require("../../../styles/NavigationPanel");
var DateUtils_1 = require("../../../util/DateUtils");
var ModelResultMetadataDetail = function (props) {
    return (React.createElement("div", { className: styles.modelResultMetadataDetail },
        React.createElement("div", null,
            props.label,
            ":\u00A0"),
        React.createElement("div", null, props.value)));
};
var ModelResultMetadata = function () {
    var modelMetadata = (0, RootReducer_1.useAppSelector)(function (state) { return state.modelResult; }).modelMetadata;
    var model = (0, RootReducer_1.useAppSelector)(function (state) { return state.predictiveModel; }).model;
    if (!modelMetadata || !model) {
        return null;
    }
    var goal = modelMetadata.goal, outcomePrediction = modelMetadata.outcomePrediction, createdBy = modelMetadata.createdBy, lastModifiedBy = modelMetadata.lastModifiedBy, type = modelMetadata.type, algorithm = modelMetadata.algorithm;
    var createdAt = model.createdAt, updatedAt = model.updatedAt;
    return (React.createElement(React.Fragment, null,
        React.createElement(ModelResultMetadataDetail, { label: Localize_1.Messages.navMetadataDateTrained(), value: (0, DateUtils_1.formatDateTime)(createdAt) }),
        React.createElement(ModelResultMetadataDetail, { label: Localize_1.Messages.targetText(), value: "".concat(goal, " ").concat(outcomePrediction) }),
        React.createElement(ModelResultMetadataDetail, { label: Localize_1.Messages.navMetadataCreatedBy(), value: createdBy }),
        React.createElement(ModelResultMetadataDetail, { label: Localize_1.Messages.navMetadataLastModifiedAt(), value: (0, DateUtils_1.formatDateTime)(updatedAt) }),
        React.createElement(ModelResultMetadataDetail, { label: Localize_1.Messages.navMetadataLastModifiedBy(), value: lastModifiedBy }),
        React.createElement(ModelResultMetadataDetail, { label: Localize_1.Messages.navMetadataType(), value: type }),
        React.createElement(ModelResultMetadataDetail, { label: Localize_1.Messages.navMetadataAlgorithm(), value: algorithm })));
};
exports.default = ModelResultMetadata;
//# sourceMappingURL=ModelResultMetadata.js.map